//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "addresslist",
  data(){
      return {
        addressList:[],
        type:'list'
      }
  },
  created() {
      this.axios.post('/xcx/User/address').then(res=>{
        this.addressList=res.data.data;
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/addresslist/addresslist.vue